<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentReport /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/manager/dashboard/HeaderDash.vue'
import SideMenu from '@/components/manager/dashboard/SideMenu.vue'
import ContentReport from '@/components/manager/dashboard/modules/report/ContentReport.vue'

export default 
{
  name: 'Report',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentReport
  }
}
</script>
<style>


</style>